import React from 'react';
import classnames from 'classnames';

import './style.scss';

const PREFIX = 'music';

export interface TagProps {
  /** 标签文本 */
  children: React.ReactNode;
  /** 自定义类名 */
  className?: string;
  /** 点击回调 */
  onClick?: () => void;
  /** 是否可关闭 */
  closable?: boolean;
  /** 关闭回调 */
  onClose?: () => void;
}

export default function Tag({ children, className, onClick, closable, onClose }: TagProps) {
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose?.();
  };

  return (
    <span
      className={classnames(
        `${PREFIX}-tag`,
        { [`${PREFIX}-tag--clickable`]: !!onClick },
        className
      )}
      onClick={onClick}
    >
      <span className={`${PREFIX}-tag__text`}>{children}</span>
      {closable && (
        <span className={`${PREFIX}-tag__close`} onClick={handleClose}>
          ×
        </span>
      )}
    </span>
  );
}
